import { Alert, Stack } from '@mui/material'
import { Layout, Switch, Text } from '@loadsmart/loadsmart-ui'
import isJson from 'common/helpers/isJSON'
import FileViewer from 'molecules/FileViewer/FileViewer'
import JsonForm from 'molecules/JsonForm/JsonForm'
import { stripNullValues } from 'molecules/JsonForm/common'
import { useMemo, useState } from 'react'

export interface ParametersEditorProps {
  formKey?: string
  schema: any
  uiSchema?: any
  data: Record<string, unknown>
  onChange: (data: Record<string, unknown>) => void
}

function ParametersEditor({ formKey, schema, uiSchema, data, onChange }: ParametersEditorProps) {
  const [isRawView, setRawView] = useState(false)

  /*
   * An unset optional Terraform variable is persisted as explicit `null` in
   * installation.parameters. Stripped so it's treated as absent instead of
   * failing its property's JSON Schema type validation
   */
  const strippedData = useMemo(() => stripNullValues(data), [data])

  const handleJsonChange = (value: string) => {
    if (!value || !isJson(value)) return
    onChange(JSON.parse(value) || {})
  }

  return (
    <Stack spacing={2}>
      <Layout.Group justify="flex-start" align="center" space="s">
        <Switch onToggle={() => setRawView(v => !v)} active={isRawView} />
        <Text>Raw visualization</Text>
      </Layout.Group>

      {!isRawView ? (
        schema ? (
          <JsonForm
            key={formKey}
            schema={schema}
            uiSchema={uiSchema}
            data={strippedData}
            onChange={({ data: changed }) => onChange(changed || {})}
          />
        ) : (
          <Alert severity="warning">This module version does not expose an input schema.</Alert>
        )
      ) : (
        <FileViewer
          contentType="application/json"
          content={JSON.stringify(data, null, 2)}
          onChange={handleJsonChange}
          options={{ heigth: 400 }}
        />
      )}
    </Stack>
  )
}

export default ParametersEditor
